import React from 'react';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { FailedAttempts } from './components/FailedAttempts';
import { Mechanism } from './components/Mechanism';
import { Deliverables } from './components/Deliverables';
import { Audience } from './components/Audience';
import { Steps } from './components/Steps';
import { Proof } from './components/Proof';
import { Faq } from './components/Faq';
import { Offer } from './components/Offer';
import { StickyCta } from './components/StickyCta';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-cream font-sans" data-id="element-0" data-mp="31ayplzmqfjy8">
      <Hero data-id="element-1" data-mp="31ctf7r8y808n" />
      <main data-id="element-2" data-mp="2wk0a329kipw1">
        <Problem data-id="element-3" data-mp="2wka0gqyiyz29" />
        <FailedAttempts data-id="element-4" data-mp="2wjqft2hhpwkj" />
        <Mechanism data-id="element-5" data-mp="2wiffxdr618yp" />
        <Deliverables data-id="element-6" data-mp="2whxbhtucnofp" />
        <Audience data-id="element-7" data-mp="28u5y0mx2p5cu" />
        <Steps data-id="element-8" data-mp="28tmfb3zlmcxr" />
        <Proof data-id="element-9" data-mp="28te3zgj4jfoo" />
        <Faq data-id="element-10" data-mp="28suv0pbgc1ms" />
        <Offer data-id="element-11" data-mp="28sbbx5a2f776" />
      </main>
      <Footer data-id="element-12" data-mp="23vkvggucm9l8" />
      <StickyCta data-id="element-13" data-mp="23w4fq47h1a2f" />
    </div>;
}